module.exports = __webpack_public_path__ + "static/media/baccarat.6cb3ac9c.png";